import { Application } from '../config'
import { Blocked, ComingSoon, Favorites, NewPasswordRequired, PaymentResult, Penalties, SignIn, SoldOut, Splash, Wallet } from '../pages'
import { configurationRoutes, configurationUrls } from './configuration'
import { newReservationRoutes, newReservationUrls } from './new-reservation'
import { recoverPasswordRoutes, recoverPasswordUrls } from './recover-password'
import { reservationsRoutes, reservationsUrls } from './reservations'
import { signUpRoutes, signUpUrls } from './sign-up'
import { verificationRoutes, verificationUrls } from './verification'

export const urls = {
  ...newReservationUrls,
  ...reservationsUrls,  
  ...signUpUrls,
  ...recoverPasswordUrls,
  ...verificationUrls,
  favorites: '/favorites',
  penalties: '/penalties',
  wallet: '/wallet',
  paymentResult: '/payment/result',
  signIn: '/sign-in',
  splash: '/',
  blocked: '/blocked',
  newPasswordRequired: '/new-password-required',
  comingSoon: '/comming-soon/:locale',
  soldOut: '/sold-out/:locale',
  config: '/configuration',
  configuration: configurationUrls
}

export const routes = [
  ...newReservationRoutes,
  ...reservationsRoutes,
  ...configurationRoutes,
  ...signUpRoutes,
  ...recoverPasswordRoutes,
  ...verificationRoutes,
  { content: Favorites, url: urls.favorites, isAuthenticated: true },
  { content: Penalties, url: urls.penalties, isAuthenticated: true },
  { content: Wallet, url: urls.wallet, isAuthenticated: true },
  { content: PaymentResult, url: urls.paymentResult, isAuthenticated: !Application.isIframe },
  { content: SignIn, url: urls.signIn, isAuthenticated: false },
  { content: NewPasswordRequired, url: urls.newPasswordRequired, isAuthenticated: false },
  { content: Blocked, url: urls.blocked, isAuthenticated: false },
  { content: ComingSoon, url: urls.comingSoon, isAuthenticated: false },
  { content: SoldOut, url: urls.soldOut, isAuthenticated: false },
  { content: Splash, url: urls.splash, isAuthenticated: false },
]
